import type * as React from 'react';
import { useState } from 'react';

import Award from '@crehana/icons/Award';
import Rocket from '@crehana/icons/fill/Rocket';
import BirreteApps from '@crehana/icons/outline/BirreteApps';
import BookOpen from '@crehana/icons/outline/BookOpen';
import CloseSmall from '@crehana/icons/outline/CloseSmall';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Col, Container, IconButton, Row } from '@crehana/ui';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

import Countdown from './Countdown';
import { useScrollContext } from './ScrollContext';
import ScrollDownButton from './ScrollDownButton';

const Main = styled.div`
  background: linear-gradient(
    90deg,
    #090915 29.9%,
    #101434 51.61%,
    #2e0e3d 76.63%
  );
`;

export interface StickyBarProps {
  endDate?: string;
  titleStickyTimer?: string;
  seeMoreButtonLabel?: string;
  isSectionCoursesActive?: boolean;
  isSectionMicrodegreesActive?: boolean;
  isSectionPacksActive?: boolean;
  isSectionPlansActive?: boolean;
}

const StickyBar: React.FC<React.PropsWithChildren<StickyBarProps>> = ({
  endDate,
  titleStickyTimer,
  seeMoreButtonLabel,
  isSectionCoursesActive,
  isSectionMicrodegreesActive,
  isSectionPacksActive,
  isSectionPlansActive,
}) => {
  const buttonsState = [
    {
      id: 1,
      label: 'Cursos con descuento',
      Icon: BirreteApps,
      sectionId: 'courses-section',
      isEnabled: isSectionCoursesActive,
    },
    {
      id: 2,
      label: 'Packs de cursos',
      Icon: Rocket,
      sectionId: 'packs-section',
      isEnabled: isSectionPacksActive,
    },
    {
      id: 3,
      label: 'Planes premium',
      Icon: Award,
      sectionId: 'premium-section',
      isEnabled: isSectionPlansActive,
    },
    {
      id: 4,
      label: 'Microdegrees',
      Icon: BookOpen,
      sectionId: 'microdegrees-section',
      isEnabled: isSectionMicrodegreesActive,
    },
  ];

  const [selectedSection, setSelectedSection] = useState<null | number>(null);
  const [hideStickyBar, setHideStickyBar] = useState(false);
  const { sectionVisible, sectionsAvailable } = useScrollContext();

  const hideButton =
    sectionVisible === sectionsAvailable[sectionsAvailable.length - 1];

  const handleCloseStickyBar = () => {
    setHideStickyBar(true);
  };

  return (
    <Main
      css={`
        transition: 0.3s;
      `}
      className={`z-7 fixed bottom-0 left-0 right-0 w-full  ${
        hideStickyBar ? 'p-0' : 'py-16'
      }`}
    >
      <div
        className={`absolute p-12 rounded-5 ${
          hideButton ? 'hidden' : 'block'
        } `}
        css={`
          top: -48px;
          left: 50%;
          transform: translate(-50%, 0);
          backdrop-filter: blur(14px);
        `}
      >
        <ScrollDownButton label={seeMoreButtonLabel} />
      </div>
      {/* If user has scrolled to the first section we let them hide the sticky bar */}
      {sectionVisible !== sectionsAvailable[0] && (
        <IconButton
          icon={{
            component: CloseSmall,
            size: 18,
          }}
          className={`absolute right-0 top-0 ${
            hideStickyBar ? 'p-0' : 'py-16'
          }`}
          withoutBorders
          isWhite
          onClick={handleCloseStickyBar}
        />
      )}
      <Container
        className={`${
          hideStickyBar ? 'hidden opacity-0' : 'block opacity-100'
        }`}
      >
        <Row>
          {/* Navigation button */}
          <Col className="hidden lg:inline-flex" lg={6}>
            <div className="flex">
              {buttonsState.map(
                el =>
                  el.isEnabled && (
                    // TODO: talk with the code owner to fix this code so we can enable this rule again
                    // eslint-disable-next-line react/button-has-type
                    // biome-ignore lint/a11y/useButtonType: legacy code - a11y/useButtonType
                    <button
                      key={el.id}
                      style={
                        selectedSection === el.id
                          ? { maxWidth: 148, opacity: 1 }
                          : { opacity: '.6' }
                      }
                      className="mr-16 py-8 px-12 rounded-5 font-link bg-base-main-dark-mode text-white flex items-center justify-center"
                      onClick={() => {
                        const DOMElement = document.getElementById(
                          el.sectionId,
                        );
                        const offsetTop = DOMElement?.offsetTop;

                        if (offsetTop) {
                          window.scroll({
                            top: offsetTop,
                            behavior: 'smooth',
                          });
                        }

                        setSelectedSection(el.id);
                      }}
                    >
                      <el.Icon
                        className="flex-shrink-0"
                        color="white"
                        size={24}
                      />
                      {selectedSection === el.id && (
                        <p className="ml-12 text-left">{el.label}</p>
                      )}
                    </button>
                  ),
              )}
            </div>
          </Col>
          {/* Countdown */}
          <Col xs={12} lg={6}>
            <div className="text-center flex flex-col items-center sm:flex-row">
              <p className="text-white font-subtitle3 mb-12 sm:mb-0 sm:mr-auto md:ml-auto md:mr-24">
                {titleStickyTimer || 'La promoción termina en: '}
              </p>
              {endDate && <Countdown dueDate={new Date(endDate)} />}
            </div>
          </Col>
        </Row>
      </Container>
    </Main>
  );
};

export default StickyBar;
